export default __webpack_public_path__ + "static/media/Vision.d8f69dd3.png";